<div class="lvi-content">
    <div class="avatar" [nSelector]="{ liste: liste, item: data }">
        <i class="material-icons-outlined align-middle">code</i>
    </div>

    <div class="lvi-body">
        <div class="title">
            <a>{{ data.description }}</a>
        </div>

        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.message.detail.balise.balise'"></strong>
                <span>{{ data.nom }}</span>
            </li>

            <li>
                <strong [translate]="'admin.bibliotheque.notifications.message.detail.balise.module'"></strong>
                <span>{{ getLibelleModule() }}</span>
            </li>

            <li>
                <strong [translate]="'admin.bibliotheque.notifications.message.detail.balise.type'"></strong>
                <span>{{ getLibelleType() }}</span>
            </li>
        </ul>
    </div>
</div>